var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
import { omit } from 'lodash';
import * as Entities from '../entities';
import * as Elements from '../elements';
export var defaultIconsDefinition = __assign(__assign({}, omit(Elements, 'IconComponent', 'IconGlyphComponent', 'SvgCircleIcon', 'SvgIcon', 'IconSheet')), Entities);
export var IconsContext = React.createContext(defaultIconsDefinition);
export var IconsProvider = createInheritedProvider(IconsContext);
export var useIcons = function () {
  return React.useContext(IconsContext);
};
export var useIcon = function (name) {
  var icons = useIcons();
  return icons[name];
};